<template>
  <BaseCard
    tile
    class="neutral tone-100 px-6"
    :hide-divider="$vuetify.breakpoint.mdAndUp"
  >
    <template #header>
      <BaseSubheader
        class="my-6 my-md-0"
      >
        <span
          class="py-4"
          :class="$vuetify.breakpoint.smAndDown ?
            'neutral--text text--tone-900' : 'brand-primary--text text--tone-400'"
        >
          {{ title }}
        </span>
      </BaseSubheader>
    </template>

    <template #content>
      <div class="d-md-none">
        <BaseFilter
          label="Type d'inscription"
          class="my-6"
          :items="filtersItems"
          modal-title="Mes inscriptions"
          :submit-button-text="filtersSubmitButtonText"
          :multiple="false"
          :text-value="filterText"
          @change="saveFilter"
          v-model="subscriptionsFilter"
        />

        <BaseButton
          class="w-100"
          color="brand-primary tone-400"
          :height="56"
          @click="$emit('filter')"
        >
          <div class="white--text text-body-m-bold">
            {{ submitText }}
          </div>
        </BaseButton>
      </div>
      <BaseCheckboxGroup
        label="Type d'inscription"
        class="mt-6 d-none d-md-block"
        :items="filtersItems"
        :multiple="false"
        :max-fields="3"
        @filter="saveFilter"
        :value="subscriptionsFilter"
      />
    </template>
  </BaseCard>
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex';
import BaseCard from '@/components/BaseCard.vue';
import BaseSubheader from '@/components/BaseSubheader.vue';
import BaseFilter from '@/components/BaseFilter.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseCheckboxGroup from '@/components/BaseCheckboxGroup.vue';
import { SET_SUBSCRIPTIONS_FILTER } from '../../store/mutation-types';

export default {
  components: {
    BaseCard,
    BaseSubheader,
    BaseFilter,
    BaseButton,
    BaseCheckboxGroup,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    filtersItems: {
      type: Array,
      required: true,
    },
    filtersSubmitButtonText: {
      type: String,
      required: true,
    },
    submitText: {
      type: String,
      default: 'Filtrer',
    },
  },
  data() {
    return {
      showAllFilters: false,
    };
  },
  computed: {
    ...mapGetters(['subscriptionList']),
    ...mapState(['subscriptionsFilter']),
    filterText() {
      const filter = this.filtersItems.find(
        (filterItem) => filterItem.id === this.subscriptionsFilter,
      );
      return filter.attributes.name;
    },
  },
  methods: {
    ...mapMutations([SET_SUBSCRIPTIONS_FILTER]),
    saveFilter(event) {
      this[SET_SUBSCRIPTIONS_FILTER](event || 0);
    },
  },
};
</script>
